import React from 'react'
import { connect } from 'react-redux'
import { openPlaceOrderDialog } from '@/actions/app';

class BuySellAction extends React.Component {
  render() {
    const { language, data } = this.props;
    return (
      <div className="item-fl-action-row">
        <button className="btn-table buy-btn" onClick={() => openPlaceOrderDialog(true, data, true)}>{language.common_buy}</button>
        <button className="btn-table sell-btn" onClick={() => openPlaceOrderDialog(false, data, true)}>{language.common_sell}</button>
      </div>
    )
  }
}

export default connect(
  state => ({
    language: state.app.language
  })
)(BuySellAction)
